import api from '../token';

export const ListUserInativo = async () => {
  try {
    const response = await api.post('/getUserInativo');
    return response.data;
  } catch (error) {
   console.error('Erro ao adicionar produto:', error);
    return [];
  }
};

